(ns frontend.ui.component.lp-portal.report.body.invest-europe.fund.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.component.overview-figures.controller :as ov-ctl]
   [frontend.ui.component.lp-portal.report.component.waterfall-chart.controller :as
    waterfall-chart-ctl]
   [frontend.ui.component.lp-portal.report.component.multi-chart.controller :as multi-controller]))

(defn overview-ui-data
  [{:keys [dynamic-path dynamic-data report-data] :as props}]
  {:overview-figures (report-ctl/with-footnote
                      props
                      :overview-figures-footnotes
                      (ov-ctl/figures (get-in report-data [:overview-figures])))
  })

(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name            (:fund-name report-data)
   :reference-date       (get-in report-data [:reference-date])
   :overview             (overview-ui-data
                          (update props :dynamic-path concat [:overview]))
   :fund-information     {:fund-value-bridge           (report-ctl/with-footnote
                                                        props
                                                        :fund-value-bridge-footnotes
                                                        (waterfall-chart-ctl/chart-config
                                                         (get-in report-data
                                                                 [:fund-value-bridge])
                                                         report-data))
                          :historical-fund-performance
                          (report-ctl/with-footnote
                           props
                           :historical-fund-performance-footnotes
                           (multi-controller/multi-chart-ctl
                            (get-in report-data
                                    [:historical-fund-performance])
                            report-data))
                          :value-progression           (report-ctl/with-footnote
                                                        props
                                                        :value-progression-footnotes
                                                        (multi-controller/multi-chart-ctl
                                                         (get-in report-data
                                                                 [:value-progression])
                                                         report-data))
                          :carried-interest-and-expenses (report-ctl/with-footnote
                                                          props
                                                          :carried-interest-and-expenses-footnotes
                                                          (:carried-interest-and-expenses report-data))
                          :fund-performance-status-1   (report-ctl/with-footnote
                                                        props
                                                        :fund-performance-status-1
                                                        (:fund-performance-status-1 report-data))
                          :fund-performance-status-2   (report-ctl/with-footnote
                                                        props
                                                        :fund-performance-status-2
                                                        (:fund-performance-status-2 report-data))}
   :fund-financials      {:balance-sheet (report-ctl/with-footnote
                                          props
                                          :balance-sheet-footnotes
                                          (:balance-sheet report-data))}
   :portfolio-information {:portfolio-summary (report-ctl/with-footnote props
                                                                        :portfolio-summary-footnotes
                                                                        (:portfolio-summary
                                                                         report-data))}
   :investor-information {:capital-account (report-ctl/with-footnote props
                                                                     :capital-account-footnotes
                                                                     (:capital-account
                                                                      report-data))}})
